import {
  FlatList as RNFlatList,
  ScrollView as RNScrollView,
  TouchableOpacity as RNTouchableOpacity,
} from 'react-native';

export const FlatList = RNFlatList;
export const ScrollView = RNScrollView;
export const TouchableOpacity = RNTouchableOpacity;
